const { isEmpty } = require('./helpers');
const { getTypeValidations } = require('./typeValidations');

/**
 * validates a field with all the validations, depends on the field type
 * @param {*} value current value
 * @param {Array} validations array of validation
 * @param {object} options object with optional parameters
 * @param {string} options.fieldType type of the current field
 * @param {string} options.fieldName field name
 * @param {*} options.objectType objectType for validation on api
 * @param {*} options.pkObjectType pkObjecType for validation on api
 * @param {*} options.globalModel globalModel for validation on api
 * @param {object} options.token para peticiones http
 * @param {string} options.mode current mode (insert or update)
 * @param {array} options.selectValues values for multi/select validations
 * @param {function} options.getFieldBydId function for unique Validation on backend mode
 * @returns {Array} an array of errors
 */
const validateField = async (value, validations, options = {}) => {
  const { fieldType } = options;
  const errors = [];
  const typeValidations = getTypeValidations(fieldType);
  const mixValidations = {
    ...validations,
    isValidType: {
      value: true,
      message: `The current value must be a ${fieldType} type`,
    },
  };
  await Promise.all(
    Object.entries(mixValidations).map(async (validation) => {
      const currentValidation = typeValidations[validation[0]];
      if (currentValidation !== undefined) {
        const result = await currentValidation(value, validation[1], options);
        errors.push(result);
      }
    })
  );

  const filteredErrors = errors.filter((element) => !isEmpty(element));

  const typeError = errors.find((item) => item === mixValidations.isValidType.message);

  if (typeError) return [typeError];
  return filteredErrors;
};

module.exports = {
  validateField,
};
